import { ChangeDetectionStrategy, Component, input, OnInit, output, signal } from "@angular/core";

import cloneDeep from "lodash-es/cloneDeep";

import { TextConstants } from "@shared/constants";
import { EntityTypeEnum, ItemsAdvanceSearchFilterTypeEnum } from "@shared/enums";
import {
  IAdvancedSearchFilterOption,
  ILocation,
  ILocationExtended,
  IProduct,
  IProductExtended,
} from "@shared/interfaces";

import { IAdvancedSearchConfig } from "../advanced-search.component";

@Component({
  standalone: false,
  selector: "app-advanced-search-items",
  templateUrl: "./advanced-search-items.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdvancedSearchItemsComponent implements OnInit {
  allProducts = input.required<IProductExtended[] | IProduct[]>();

  allLocations = input.required<ILocationExtended[] | ILocation[]>();

  initialSearch = input<any>(undefined);

  searchChanged = output<any>();

  config = signal<IAdvancedSearchConfig>(undefined);

  ngOnInit(): void {
    const allProductsOptions: IAdvancedSearchFilterOption[] = this.allProducts().map((p) => ({
      label: p.name,
      value: p.id,
    }));

    const allLocationsOptions: IAdvancedSearchFilterOption[] = this.allLocations().map((p) => ({
      label: p.name,
      value: p.id,
    }));

    const outputSearchPropertyName = "itemId";

    this.config.set({
      entityType: EntityTypeEnum.ITEMS,
      outputSearchPropertyName,
      filters: [
        {
          label: TextConstants.PRODUCT,
          options: allProductsOptions,
          outputValuesPropertyName: ItemsAdvanceSearchFilterTypeEnum.PRODUCTS_IDS,
        },
        {
          label: TextConstants.CREATED_AT_LOCATION,
          options: cloneDeep(allLocationsOptions),
          outputValuesPropertyName: ItemsAdvanceSearchFilterTypeEnum.CREATED_AT_LOCATION_IDS,
        },
        {
          label: TextConstants.CURRENT_LOCATION,
          options: cloneDeep(allLocationsOptions),
          outputValuesPropertyName: ItemsAdvanceSearchFilterTypeEnum.CURRENT_LOCATION_IDS,
        },
      ],
    });
  }
}
